exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-in-page.opened .block-in-page-detail[data-v-42d317c2]{overflow:visible}.fancybox-inner[data-v-42d317c2]{overflow:hidden!important}.fancybox-nav[data-v-42d317c2]{width:40px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42d317c2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Content/src/views/edit/TasksEdit.vue
// module id = 784
// module chunks = 1